import { ContractTypes } from '@src/app/core/enum/contract-types.enum';

export const DOMESTIC_TYPES = [
  ContractTypes.CONTRATO_ADHESION_DOMESTICO, // A
  ContractTypes.REPRESENTANTES_AUTORIZADO, // R
  ContractTypes.ENVASES_SERVICIO, // E
];

export const COMMERCIAL_TYPES = [
  ContractTypes.CONTRATO_SCRAP_COMERCIAL, // M
  ContractTypes.REPRESENTANTE_AUTORIZADO_COMERCIALES, // X
];

export const CIRCULAR_CHECK_TYPES = [ContractTypes.CIRCULAR_CHECK]; // J
export const EUROPEAN_DESK_TYPES = [ContractTypes.EUROPEAN_DESK]; // U
export const POSEEDOR_FINAL_TYPES = [
  ContractTypes.POSEEDOR_FINAL_GESTION_INTEGRAL, // G
  ContractTypes.POSEEDOR_FINAL_COSTE_ESTANDAR,   // PFCE
];

export const ALL_CATALOGUED_TYPES: ContractTypes[] = [
  ...DOMESTIC_TYPES,
  ...COMMERCIAL_TYPES,
  ...CIRCULAR_CHECK_TYPES,
  ...EUROPEAN_DESK_TYPES,
  ...POSEEDOR_FINAL_TYPES,
];

export const CONTRACT_NAMES = {
  DOMESTIC: 'Adhesión Ecoembes Domésticos',
  COMMERCIAL: 'Adhesión Ecoembes Comercial',
  CIRCULAR_CHECK: 'CircularCheck',
  EUROPEAN_DESK: 'European Desk',
  BUSINESS_PLANS: 'Planes empresariales de Prevención',
  PRODUCER: 'Registro de Productores',
  POSEEDOR_FINAL: 'Contrato de Poseedor Final',
};
